import { useMemo } from "react"
import { Flex, Typography } from "antd"

import loader from "@src/app/assets/upload-loader.svg"
import { IImageUploadProgress } from "@src/shared/componemts/ImageUploadUI/entity/Uploaded"

type Props = {
  progress: IImageUploadProgress
}
export const ImageUploadIsLoading = ({ progress }: Props) => {
  const percent = useMemo(() => {
    return Math.floor(progress.percent / 5) * 5
  }, [progress.percent])

  return (
    <Flex align="center" gap={16} vertical>
      <img
        src={loader}
        style={{ height: 48, objectFit: "contain", width: 48 }}
      ></img>

      <Typography.Title level={5} style={{ margin: 0, textAlign: "center" }}>
        file upload in progress {percent} %
      </Typography.Title>
    </Flex>
  )
}
